
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ae-en/grocery-pos-billing-software-uae",
      function () {
        return require("private-next-pages/ae-en/grocery-pos-billing-software-uae.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ae-en/grocery-pos-billing-software-uae"])
      });
    }
  